export function extractEntidadesCounts(propertyData) {
  const props = propertyData?.properties || {};
  const key = Object.keys(props).find((k) => k.toLowerCase() === 'entidades');
  const data = key ? props[key] : null;
  const list = Array.isArray(data) ? data : data ? [data] : [];

  let pf = 0;
  let pj = 0;

  for (const raw of list) {
    if (!raw || typeof raw !== 'object') continue;
    let tipo = raw.tipo;
    if (!tipo) {
      const tdoc = (raw.tipo_documento || raw.tipoDocumento || '').toUpperCase();
      if (tdoc === 'CPF') tipo = 'PF';
      else if (tdoc === 'CNPJ') tipo = 'PJ';
    }
    if (!tipo) {
      const doc = (raw.documento || raw.cadastro?.ni || '').replace(/\D/g, '');
      if (doc.length === 11) tipo = 'PF';
      else if (doc.length === 14) tipo = 'PJ';
    }
    if (!tipo) tipo = 'PJ';

    if (String(tipo).toUpperCase() === 'PF') pf += 1;
    else pj += 1;
  }

  return { total: pf + pj, pf, pj };
}
